/* eslint-disable  */
/* eslint-disable no-case-declarations */
import React from 'react';
import {connect} from 'react-redux';
import Unity from 'react-unity-webgl';
import {awardCS2NElementRequirement, getGenericContent} from '../reducers/cs2n';
import styles from '../css/load-splash.css';
import {FaHourglassHalf} from 'react-icons/fa';
import { setUnityContent } from '../lib/cmra-data-collection';


class UnityPane extends React.Component {
    constructor (props) {
        super(props);
        this.unityElement = null;
        this.setUnityRef = element => {
            this.unityElement = element;
        };
        this.sendUnityMessage = this.sendUnityMessage.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.completeRequirable = this.completeRequirable.bind(this);
    }

    componentDidMount () {
        const {unity, vm} = this.props;
        window.unity = unity;
        setUnityContent(unity);
        unity.on('GameStatus', message => {
            message = JSON.parse(message);
            switch (message.topic) {
                case 'open_PI':                
                this.props.openPI(null);
                break;
            case 'complete-requirable':
                this.completeRequirable();
                break;
                case 'program-start':
            this.sendUnityMessage(
            {
                topic: 'program-data-request',
                message: {
                    method: 'logProgramData',
                    parameters: {
                        block_program: vm.toJSON()
                    }
                }
            },
            unity
        );
                this.props.vm.greenFlag();
                break;
            case 'program-stop':
                this.props.vm.stopAll();
                    break;
                case 'opt-in-data':
                    this.props.createNewPlaySession();
                    break;
            case 'unity_awake':
                
                // Removes loading splash
                document.getElementById('load_splash').style.display = 'none';
                    if (this.props.disableCS2N == null) {
                        const configuration =
                            this.props.cs2n.config ? JSON.parse(this.props.cs2n.config.configuration) : { scene: '' };
                        const sceneName = configuration.scene;
                        if (configuration.content) {
                            this.props.getGenericContent(configuration.content);
                        }
                    
                        // eslint-disable-next-line no-case-declarations
                        const outgoing = {
                            topic: 'game-settings',
                            message: {
                                method: 'LoadAssetBundles',
                                parameters: {
                                    s_scene: sceneName
                                }
                            }
                        };
                        this.sendUnityMessage(outgoing, unity);
                    }
                    this.props.loadDefaultProject();

                break;
            
            }
            
        });

    
    
        // This prevents the vm runtime from failing on early messages.
        unity.on('MessageFromUnity', () => null);

        document.addEventListener('click', this.handleClickOutside, true);
        vm.runtime.attachUnity(unity);
    }

    componentWillUnmount () {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    completeRequirable () {
        this.props.awardCS2NElementRequirement();
    }

    handleClickOutside (event) {
        if (this.unityElement && !this.unityElement.contains(event.target)) {
            this.enableKeyboard(false);
        }
    }

    enableKeyboard (enabled) {
        this.sendUnityMessage(
            {
                topic: 'settings',
                message: {
                    method: 'toggleKeyboard',
                    parameters: {
                        b_toggleKeyboard: enabled
                    }
                }
            },
            this.props.unity
        );
    }

    sendUnityMessage (msg, unity) {
        const message = JSON.stringify(msg);
        unity.send('UnityMessenger', 'UnityMessengerDispatcher', message);
    }

    getInlineStyle () {
        if (this.props.isFullscreen) {
            return { position: "absolute", zIndex: 100, top:0, right:0, overflow: 'hidden'};
        }
        else
            return { position: "absolute", zIndex: 100, marginTop: '10px', right: '30px' };
    }
    render () {
        return (
            <div style={this.getInlineStyle()}>
                <div
                    id="load_splash"
                    className={styles.load_splash}>
                    <span>
                        <FaHourglassHalf />
                        Loading. Please wait...
                    </span>
                </div>
                <Unity
                    unityContext={this.props.unity}
                    style={{
                        width: this.props.width,
                        height: this.props.height
                    }}
                />
            </div>
        );
    }
}


const mapStateToProps = state => {
    const {unity, vm, cs2n} = state.scratchGui;
    return {
        unity,
        vm,
        cs2n
    };
};


export default connect(mapStateToProps, { awardCS2NElementRequirement, getGenericContent })(
    UnityPane
);
